import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./../home/home.css";
import { Link, useNavigate } from "react-router-dom";
import InteraktScript from "../../common/InteraktScript";

function Doctorprofile() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [userid, setUserid] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const userIdValue = localStorage.getItem("userId");
    setUserid(userIdValue);
  }, [userid]);

  useEffect(() => {
    const slider = document.querySelector(".auto-scroll-container");
    if (!slider) return;

    let scrollAmount = 0;
    const slide = () => {
      if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
        scrollAmount = 0;
      } else {
        scrollAmount += slider.clientWidth * 0.9;
      }
      slider.scrollTo({
        left: scrollAmount,
        behavior: "smooth",
      });
    };

    const interval = setInterval(slide, 4000);
    return () => clearInterval(interval);
  }, []);

  const doctors = [
    {
      id: 1,
      name: "Dr. Aaradhya Sharma",
      specialization: "Gynaecologist & Your Pregnancy Friend",
      degrees: "MBBS, DGO, MD (Obs & Gyn)",
      Experience: "11 Years of Experience",
      drtext: "My goal is to make you feel so safe and heard, you forget you're talking to a doctor.",
      image: "/Doctorprofile.png",
      link: "/Dr-Aaradhya-Sharma",
    },
    {
      id: 2,
      name: "Dr. Vikram Singh",
      specialization: "Gynaecologist & Your Expert Confidante",
      degrees: "MBBS, DGO (Obs & Gyn)",
      Experience: "16 Years of Experience",
      drtext:"My mission is to replace the fear of the unknown with the confidence that comes from understanding your journey.",
      image: "/Doctorprofile.png",
      link: "/Dr-Vikram-Singh",
    },
    {
      id: 3,
      name: "Dr. Chayya Palan​",
      specialization: "Emotional Health Expert & Partner in Mind-Body Wellness​",
      degrees: "MSc (Clinical Psychology), Advance Diploma in Counselling Psychology",
      Experience: "11 Years of Experience",
      drtext: "A healthy baby begins with a happy, peaceful mother. We're here to care for both of you.",
      image: "/Doctorprofile.png",
      link: "/Dr-Chayya-Palan",
    },
    {
      id: 4,
      name: "Dr. Anuradha Tikhe​",
      specialization: "Dietitian, Your Steady Hand & Reassuring Voice​",
      degrees: "BHMS, MPH (Mumbai), Certified Pregnancy Nutritionist",
      Experience: "16+ Years of Experience",
      drtext: "In all my years of practice, one thing is constant: the need for a calm, experienced hand to hold",
      image: "/Doctorprofile.png",
      link: "/Dr-Anuradha-Tikhe-Dietitian",
    },
        {
      id: 5,
      name: "Dr. Deepak Bhuktar​",
      specialization: "Physician & Your Health Cheerleader​",
      degrees: "MBBS, MD (Internal Medicine)",
      Experience: "15 Years of Experience",
      drtext: "Pregnancy is a celebration of what your body can do! My goal is to make it a joyful and empowering experience.",
      image: "/Doctorprofile.png",
      link: "/Dr-Deepak-Bhuktar",
    },
        {
      id: 6,
      name: "Dr. Gayatri Navale​",
      specialization: "Gynaecologist & Your Safe Space​",
      degrees: "MBBS, DGO, MD (Obs & Gyn)",
      Experience: "13 Years of Experience",
      drtext: "There is no such thing as a 'silly question' or a 'small fear.' Here, everything you feel is valid and important",
      image: "/Doctorprofile.png",
      link: "/Dr-Gayatri-Navale​",
    },
        {
      id: 7,
      name: "Dr. Nisha Kapoor​",
      specialization: "Senior Gynaecologist & Myprega Mentor​",
      degrees: "MBBS, DGO, MD (Obs & Gyn)",
      Experience: "30 Years of Experience",
      drtext: "We are here to transform maternal care from a clinical transaction into a supportive, human relationship",
      image: "/Doctorprofile.png",
      link: "/Dr-Nisha-Kapoor​",
    },
        {
      id: 8,
      name: "Dr. Anuradha Tikhe​",
      specialization: "Mind-Body Guide & Prenatal Yoga Expert​",
      degrees: "BHMS, MPH (Mumbai), Certificate Of Prenatal & Postnatal Yoga",
      Experience: "16+ Years of Experience",
      drtext: "We don't just prepare your body for birth; we train your mind for the beautiful journey of motherhood",
      image: "/Doctorprofile.png",
      link: "/Dr-Anuradha-Tikhe-Yoga",
    },
        {
      id: 9,
      name: "Dr. Anand Narnaware​",
      specialization: "Paediatrician & Your Baby's First Friend​",
      degrees: "MBBS, DNB - Paediatrics, DCH",
      Experience: "17 Years of Experience",
      drtext: "My role begins before your baby arrives, giving you the confidence to welcome your newborn into a healthy, happy home",
      image: "/Doctorprofile.png",
      link: "/Dr-Anand-Narnaware",
    },
        {
      id: 10,
      name: "Crystal Clear Imaging (IIMS Hospital)",
      specialization: "Radiologist & Your Window to the Womb​",
      degrees: "MBBS, MD (Radiodiagnosis), Fellowship in Foetal Medicine",
      Experience: "18 Years of Experience​",
      drtext: "Through my lens, you get the first glimpse of your baby. I ensure every image is a story of health and reassurance",
      image: "/Doctorprofile.png",
      link: "/Crystal-Clear-Imaging-Content",
    },

  ];


  return (
    <div className="new-home">
      <Header userid={userid} />

      <div className="banner-container position-relative round-back margin-top  ">
        <div className="container-fluid   py-5">
          <div className="row align-items-center ">
            <div className="col-md-6">
              <h1 className="hero-title text-red">
                More Than a Doctor. Your Partner in Pregnancy.
              </h1>
              <p className="under-subtitle py-4 text-gray-600">
                 At Myprega, we believe the best care comes from a deep, human connection.
                 We don't just find great doctors; we find incredible people, and empower them to be your
                 personal guide, friend, and confidante on this beautiful journey.
              </p>
            </div>
            <div className="col-md-6 order-mobile">
              <img src="/Doctorprofile.png" alt="nt found"></img>
            </div>
          </div>
        </div>
      </div>

       <div className="bg-light py-5" style={{ minHeight: "100vh",  }}>
         <div className="container h-100">
           <div className="row h-100 align-items-center justify-content-center">
             <div className="col-md-8 text-center">
               <h2 className="hero-title text-red">Why a Myprega Doctor is Different</h2>
               <p className="bold-font" style={{paddingBottom: "80px"}}>
                 You deserve more than just a medical professional. You deserve a partner who listens,
                 an expert who empathizes, and a guide who cares for you like your mother. That's why
                 our selection and training process is unlike any other in India. We don't just look for
                 qualifications; we look for character.
               </p>
             </div>
           </div>


      
           <div
             style={{
               display: "flex",
               flexDirection: window.innerWidth < 768 ? "row" : "row",
               flexWrap: window.innerWidth < 768 ? "nowrap" : "wrap",
               justifyContent: window.innerWidth < 768 ? "flex-start" : "space-between",
               overflowX: window.innerWidth < 768 ? "auto" : "visible",
               scrollSnapType: window.innerWidth < 768 ? "x mandatory" : "none",
               gap: "16px",
               paddingBottom: "10px",
             }}
           >
             <div
               style={{
                 flex: window.innerWidth < 768 ? "0 0 90%" : "0 0 32%",
                 scrollSnapAlign: "start",
                 backgroundColor: "#fff",
                 borderRadius: "12px",
                 padding: "20px",
                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                 textAlign: "center",
                 minWidth: window.innerWidth < 768 ? "90%" : "unset",
               }}
             >
              <div className="benefit-icon green">
                 <img src="/DoctorprofileIcon1.png" alt="Benefit Icon" className="icon" />
               </div>

               <h4 style={{ color: "#a4103a", fontWeight: "bold" , paddingBottom: "10px",}}>
                 Handpicked Human Expertise
               </h4>
               <p style={{ fontSize: "15px", color: "#333" }}>
                 Our journey begins by finding not just the most
                 qualified gynaecologists, but the most compassionate ones. We search for doctors who see
                 pregnancy not as a medical condition, but as a profound human experience. Every doctor is
                 personally interviewed to understand their core philosophy, their communication style, and their
                 capacity for empathy. We ask them about the books they read, their view on a mother's intuition,
                 analyse their thought process, and how they build trust. Only those who align with our
                 "care-like-a-mother" philosophy are invited to join.
               </p>
             </div>
             <div
               style={{
                 flex: window.innerWidth < 768 ? "0 0 90%" : "0 0 32%",
                 scrollSnapAlign: "start",
                 backgroundColor: "#fff",
                 borderRadius: "12px",
                 padding: "20px",
                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                 textAlign: "center",
                 minWidth: window.innerWidth < 768 ? "90%" : "unset",
               }}
             >
               <div className="benefit-icon green">
                  <img src="/DoctorprofileIcon2.png" alt="Benefit Icon" className="icon" />
                </div>

               <h4 style={{ color: "#a4103a", fontWeight: "bold" , paddingBottom: "10px",}}>
                 The Myprega Empowerment Training
               </h4>
               <p style={{ fontSize: "15px", color: "#333" }}>
                 This is our promise. Once a doctor joins our
                 family, they undergo rigorous Myprega-exclusive training. This isn't about medicine—they are
                 already experts in that. This is about mastering the art of connection. Our Standard Operating
                 Procedures (SOPs) are built around empathy, active listening, taking care of your’s like mother,
                 and empowering you with knowledge. We train them to be your friend first, to answer the "silly"
                 questions with patience, to celebrate your joys, and to calm your fears with genuine warmth.
                 You will not find this level of emotional and communication training in any hospital across India.
               </p>
             </div>
             <div
               style={{
                 flex: window.innerWidth < 768 ? "0 0 90%" : "0 0 32%",
                 scrollSnapAlign: "start",
                 backgroundColor: "#fff",
                 borderRadius: "12px",
                 padding: "20px",
                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                 textAlign: "center",
                 minWidth: window.innerWidth < 768 ? "90%" : "unset",
               }}
             >
               <div className="benefit-icon green">
                  <img src="/DoctorprofileIcon3.png" alt="Benefit Icon" className="icon" />
                </div>

               <h4 style={{ color: "#a4103a", fontWeight: "bold" , paddingBottom: "10px", }}>
                 Empowered by Technology, Driven by Heart
               </h4>
               <p style={{ fontSize: "15px", color: "#333" }}>
                 We then empower these incredible
                 doctors with our technology. Our platform handles the logistics, reminders, reports, and data,
                 freeing your doctor to do what they do best: focus completely on you. This framework ensures
                 you get the best of both worlds—the structured, reliable support of Myprega and the
                 personalized, human touch of a doctor who knows you and your story
               </p>
             </div>
            </div>
            <p style={{ textAlign: "center" , fontSize: "18px" , paddingTop: "10px" ,color: "#0084f5"}}>We handpicked, vet, and train the best medical experts for
                 and then we empower them with our tech. We don't hide our doctors behind our brand. We
                ate them, so they can elevate your care</p>
           </div>
          </div>

           <div className="bg-white py-4">
             <div className="container h-100">
               <div className="row h-100 align-items-center justify-content-center">
                 <div className="col-md-8 text-center">
                   <h2 className="hero-title text-red">
                     Meet Your Pregnancy Friends & Guides
                   </h2>
                   <p className="bold-font" style={{paddingBottom: "50px"}}>
                     Below are the incredible individuals who form the heart of Myprega. They are
                     doctors, yes, but they are firstly kind human beings, also mentors, listeners, and passionate
                     advocates for your well-being. Get to know the person who will be walking alongside you. We
                     firmly believe the philosophy that “The good physician treats the disease; the great physician
                     treats the patient.”
                   </p>
                 </div>
               </div>
             </div>
           </div>


         <div className="container pt-3 pb-5">
           <div className="row">
             {doctors.map((doctor) => (
               <div className="col-md-6 mb-4" key={doctor.id}>
                 <div
                   className="d-flex flex-column flex-md-row"
                   style={{
                     border: "1px solid #ccc",
                     borderRadius: "32px",
                     overflow: "hidden",
                     backgroundColor: "#fff",
                   }}
                 >
                   <div className="d-flex justify-content-center align-items-center p-3">
                     <img
                       src={doctor.image}
                       alt={doctor.name}
                       style={{
                         width: "220px",
                         height: "220px",
                         borderRadius: "50%",
                         objectFit: "cover",
                         flexShrink: 0,
                       }}
                     />
                   </div>
         
                   <div
                     className="d-none d-md-block"
                     style={{
                       width: "2px",
                       backgroundColor: "#ddd",
                       margin: "16px 0",
                     }}
                   ></div>
         
                   <div style={{ padding: "16px", flex: 1 }}>
                     <h5>{doctor.name}</h5>
                     <p style={{ margin: 0, fontWeight: "bold" }}>
                       {doctor.specialization}
                     </p>
                     <p style={{ marginBottom: "0px" }}>{doctor.degrees}</p>
                     <p style={{ marginBottom: "22px" }}>{doctor.Experience}</p>
                     <p style={{ marginBottom: "10px" }}>"{doctor.drtext}"</p>
                     <Link
                       to={
                         doctor.link ||
                         `/doctor/${doctor.name.toLowerCase().replace(/\s+/g, "-")}`
                       }
                       className="btn btn-primary"
                     >
                       View Profile
                     </Link>
                   </div>
                 </div>
               </div>
             ))}
           </div>
         </div>
      
      <Footer />
      <InteraktScript />
    </div>
  );
}

export default Doctorprofile;
